import { render, staticRenderFns } from "./ProcessedDocs.vue?vue&type=template&id=18cdc6bc"
import script from "./ProcessedDocs.vue?vue&type=script&lang=js"
export * from "./ProcessedDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports